import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmploymentRecordRelocation, EmploymentRecordRelocationSubmit } from '../models/employment-record-relocation.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class EmploymentRecordRelocationService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getRelocations(employeeId: string, employmentRecordId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http
      .get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Relocation`, {
        headers: headers,
        observe: 'response',
        params: params
      })
      .pipe(
        catchError(err => throwError(err)),
        map(res => {
          let data = {
            relocations: res.body,
            pagination: JSON.parse(res.headers.get('X-Pagination'))
          }

          return data;
        })
      );
  }

  getRelocation(employeeId: string, employmentRecordId: string, relocationId: string): Observable<EmploymentRecordRelocation> {
    return this.http.get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Relocation/${relocationId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  postRelocation(employeeId: string, employmentRecordId: string, relocation: EmploymentRecordRelocationSubmit): Observable<EmploymentRecordRelocation> {
    return this.http.post<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Relocation`, relocation, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  deleteRelocation(employeeId: string, employmentRecordId: string, relocationId: string): Observable<any> {
    return this.http.delete<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Relocation/${relocationId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

